import { AnyAction } from "redux";
import { takeLatest, call, put, getContext } from "redux-saga/effects";
import { LOGIN_COMPLETE } from "../../common/redux/actions";
import { API_ROOT_COMMS } from "../config";
import {
  MAGIC_LOGIN_RECEIVING_TOKEN,
  MAGIC_LOGIN_REQUESTING_TOKEN,
} from "./actions";
import { History } from "history";

const requestEmail = async (
  resourceType: string,
  resourceId: string,
  email: string
) => {
  const url = `${API_ROOT_COMMS}/share/${resourceType}/${resourceId}/generate`;

  await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email }),
  });
};

function* receivingTokenSaga() {
  const history: History = yield getContext("history");
  // get rid of the token from the url
  yield call(() => history.push(history.location.pathname));
}

function* requestTokenSaga({ payload }: AnyAction) {
  const { resourceType, resourceId, emailAddress } = payload as {
    emailAddress: string;
    resourceType: string;
    resourceId: string;
  };
  yield call(requestEmail, resourceType, resourceId, emailAddress);
  yield put({ type: LOGIN_COMPLETE, payload });
}

export function* rootSaga() {
  yield takeLatest(MAGIC_LOGIN_REQUESTING_TOKEN, requestTokenSaga);
  yield takeLatest(MAGIC_LOGIN_RECEIVING_TOKEN, receivingTokenSaga);
}
